import { render, staticRenderFns } from "./Apartments.vue?vue&type=template&id=b9d46174"
import script from "./Apartments.vue?vue&type=script&lang=ts"
export * from "./Apartments.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports